import useFilterSearchListener from './hooks/useFilterSearchListener';

export function createOpenUtil() {
  if (!window.cnChartsUtils) {
    window.cnChartsUtils = {
      hook: {
        useFilterSearchListener,
      },
    };
  }
}
